import axios from '../../helpers/axios-setup';
import { AxiosResponse } from 'axios';
import { Note, NoteTypes } from '../../components/partials/notes/types';

export const createNote = (
  { id, note }: { id: number; note: string },
  type = NoteTypes.APPLICATION,
): Promise<AxiosResponse<Note>> => axios.post(`/notes/${type}/${id}`, { text: note });
